import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import {
  MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID,
  MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID,
} from "../constants";
import { ModuleVersionModuleDependencyRow, ModuleVersionProviderDependencyRow } from "../types";
import ModuleVersionDependenciesTableDropdownCell from "./DropdownCell";
import ModuleVersionDependenciesTableNameCell from "./NameCell";
import ModuleVersionDependenciesTableSourceCell from "./SourceCell";
import ModuleVersionDependenciesTableVersionCell from "./VersionCell";

export const MODULE_VERSION_MODULE_DEPENDENCIES_TABLE_CELLS: Record<
  MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionModuleDependencyRow>) => JSX.Element
> = {
  [MODULE_VERSION_MODULE_DEPENDENCIES_COLUMN_ID.NAME]: ModuleVersionDependenciesTableNameCell,
};

export const MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_CELLS: Record<
  MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionProviderDependencyRow>) => JSX.Element
> = {
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME]: ModuleVersionDependenciesTableNameCell,
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.VERSION]:
    ModuleVersionDependenciesTableVersionCell,
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.SOURCE]: ModuleVersionDependenciesTableSourceCell,
  [MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.DROPDOWN]:
    ModuleVersionDependenciesTableDropdownCell,
};
